// removed by extract-text-webpack-plugin
module.exports = {"root":"_UsZ4t","correct":"_1lfh0","incorrect":"_jwaZa","finished":"_2VZc0"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Post/components/PostContent/components/ContentBlock/components/QuizBlock/components/AnswerBlock/components/ExplanationBlock/ExplanationBlock.scss
// module id = 1172
// module chunks = 2